import React, { useEffect, useState } from "react";
import { PurchaseOrderListItem } from "../types";
import "../pages/PurchaseOrders.css";

export interface PurchaseCancelModalProps {
  order: Pick<PurchaseOrderListItem, "purchaseOrderId" | "number" | "supplierName">;
  /** Sunucu hatası (sayfa verir); modal açık kalır. */
  error?: string;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

const closeIcon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>;

/** Siparişi sebep girerek iptal et (sebep zorunlu, en az 3 karakter — sunucu kuralı). */
const PurchaseCancelModal: React.FC<PurchaseCancelModalProps> = ({ order, error, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const valid = reason.trim().length >= 3;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape" && !busy) { e.stopPropagation(); onClose(); } };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose, busy]);

  const submit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    try { await onConfirm(reason.trim()); } finally { setBusy(false); }
  };

  return (
    <div className="po-overlay center top" onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onClose(); }}>
      <form className="po-modal" role="dialog" aria-modal="true" aria-labelledby="po-cancel-title" onSubmit={submit}>
        <div className="po-modal-head">
          <div><span className="po-kicker">{order.number} · {order.supplierName}</span><h3 id="po-cancel-title">Siparişi iptal et</h3></div>
          <button type="button" className="po-ib big" aria-label="Kapat" onClick={onClose} disabled={busy}>{closeIcon}</button>
        </div>
        <div className="po-modal-body">
          <p className="po-form-hint">İptal edilen sipariş yeniden açılamaz. Sebep sipariş kartında görünür.</p>
          {error && <div className="po-note err" role="alert">{error}</div>}
          <label className="po-field">
            <span>İptal sebebi<em>zorunlu, en az 3 karakter</em></span>
            <textarea rows={3} maxLength={300} autoFocus value={reason} placeholder="Örn. tedarikçi temin edemiyor"
              onChange={(e) => setReason(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) submit(); }} />
          </label>
          <span className="po-counter">{reason.length}/300</span>
        </div>
        <div className="po-modal-foot">
          <button type="button" className="po-btn" onClick={onClose} disabled={busy}>Vazgeç</button>
          <button type="submit" className="po-btn primary danger" disabled={busy || !valid}>{busy ? "İptal ediliyor" : "Siparişi iptal et"}</button>
        </div>
      </form>
    </div>
  );
};

export default PurchaseCancelModal;
